import { AnyAction } from "redux";
import { FindById, Update } from "../../../../controllers/entities";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";

export const FETCH_UPDATE_ENTITY_REQUEST = "FETCH_UPDATE_ENTITY_REQUEST";
export const FETCH_UPDATE_ENTITY_SUCCESS = "FETCH_UPDATE_ENTITY_SUCCESS";
export const FETCH_UPDATE_ENTITY_FAILURE = "FETCH_UPDATE_ENTITY_FAILURE";
export const SET_UPDATE_ENTITY = "SET_UPDATE_ENTITY";

interface ActionPagination<T> {
  type: string;
  payload: T;
}

const fetchUpdateDataRequest = () => {
  return {
    type: FETCH_UPDATE_ENTITY_REQUEST,
  };
};

const fetchUpdateDataSuccess = (data: any): ActionPagination<Result<any>> => {
  return {
    type: FETCH_UPDATE_ENTITY_SUCCESS,
    payload: data,
  };
};

const fetchUpdateDataFailure = (error: any) => {
  return {
    type: FETCH_UPDATE_ENTITY_FAILURE,
    payload: error,
  };
};

export const setUpdateEntity = (data: any) => {
  return {
    type: SET_UPDATE_ENTITY,
    payload: data,
  };
};

export const updateEntity = (id: string, data: any) => {
  return async (dispatch: Dispatch<AnyAction>) => {
    dispatch(fetchUpdateDataRequest());
    try {
      const response = await Update(id, data);
      dispatch(fetchUpdateDataSuccess(response.data));
    } catch (error: any) {
      dispatch(fetchUpdateDataFailure(error.message));
    }
  };
};

export const findById = (id: string) => {
  return async (dispatch: Dispatch<AnyAction>) => {
    dispatch(fetchUpdateDataRequest());
    try {
      const response = await FindById(id, "fields=*.*");

      console.log("response entity", response.data);

      dispatch(setUpdateEntity(response.data));
    } catch (error: any) {
      dispatch(fetchUpdateDataFailure(error.message));
    }
  };
};
